<template>
  <v-data-table
    :headers="headers"
    :items="users"
    :value="value"
    item-key="id"
    hide-actions
    select-all
    @input="input"
  >
    <template slot="items" slot-scope="props">
      <tr :active="props.selected">
        <td>
          <v-checkbox
            v-model="props.selected"
            :class="`select-user-${props.item.id}`"
            hide-details
          />
        </td>
        <td>
          {{ props.item.full_name }}
        </td>
        <td>
          {{ props.item.email }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'UsersTable',
  props: {
    headers: {
      type: Array,
      default: () => [
        { text: 'Name', value: 'full_name' },
        { text: 'E-Mail', value: 'email' },
      ],
    },
    users: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    input(selected) {
      this.$emit('input', selected);
    },
  },
};
</script>
